import { io } from 'socket.io-client';
import type { Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '@goanna-im/shared';

// Socket.IO client generics are <ListenEvents, EmitEvents>.
export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: AppSocket | null = null;

/**
 * The app talks to a single origin: in dev, Vite proxies /socket.io to the server;
 * in production the server hosts the built app. Override with VITE_SERVER_URL only
 * when the server lives on a different host/port.
 */
export function getSocket(): AppSocket {
  if (!socket) {
    const url = import.meta.env.VITE_SERVER_URL || undefined;
    socket = io(url, {
      autoConnect: true,
      // Default polling-first with auto-upgrade to websocket — the most compatible
      // path across the Vite dev proxy and the production Fastify host.
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionDelay: 500,
      reconnectionDelayMax: 4000,
    });
  }
  return socket;
}
